/* CleanRide: ficha de producto (sections/cr-producto.liquid).
   Galería deslizable con ampliación, fechas de entrega en días laborables y barra fija en móvil.
   Nada de esto bloquea la compra: si falla, la ficha sigue funcionando con el formulario nativo. */
(function () {
  // ---- Galería --------------------------------------------------------------
  if (!customElements.get('cr-galeria')) {
    class CrGaleria extends HTMLElement {
      connectedCallback() {
        if (this._listo) return;
        this._listo = true;
        this.pista = this.querySelector('[data-pista]');
        this.minis = this.querySelector('[data-minis]');
        this.indice = 0;
        this.lb = this.querySelector('[data-lb]');
        if (!this.pista) return;

        var tick = false;
        this.pista.addEventListener('scroll', function () {
          if (tick) return;
          tick = true;
          requestAnimationFrame(function () {
            tick = false;
            this.marcar(Math.round(this.pista.scrollLeft / this.pista.clientWidth));
          }.bind(this));
        }.bind(this), { passive: true });

        this.querySelectorAll('[data-mover]').forEach(function (b) {
          b.addEventListener('click', function () {
            this.pista.scrollBy({ left: this.pista.clientWidth * +b.dataset.mover, behavior: 'smooth' });
          }.bind(this));
        }, this);

        // Miniaturas: al pulsar una, la galería va a esa foto
        if (this.minis) {
          this.minis.addEventListener('click', function (e) {
            var b = e.target.closest('[data-ir]');
            if (b) this.pista.scrollTo({ left: this.pista.clientWidth * +b.dataset.ir, behavior: 'smooth' });
          }.bind(this));
        }

        // Vídeo de la galería: iOS necesita playsinline para reproducirse dentro de la página;
        // se reproduce solo cuando está en pantalla.
        var v = this.querySelector('.cr-gal-video');
        if (v) {
          v.playsInline = true;
          v.muted = true;
          if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (es) {
              es.forEach(function (e) { e.isIntersecting ? v.play().catch(function () {}) : v.pause(); });
            }, { threshold: 0.5 }).observe(v);
          }
        }

        this.pista.addEventListener('click', function (e) {
          var b = e.target.closest('[data-i]');
          if (b) this.abrir(+b.dataset.i);
        }.bind(this));

        if (this.lb) {
          this.querySelector('[data-lb-cerrar]').addEventListener('click', function () { this.lb.close(); }.bind(this));
          this.lb.addEventListener('keydown', function (e) {
            var p = this.lb.querySelector('[data-lb-pista]');
            if (e.key === 'ArrowRight') p.scrollBy({ left: p.clientWidth });
            if (e.key === 'ArrowLeft') p.scrollBy({ left: -p.clientWidth });
          }.bind(this));
        }
      }

      // Marca la miniatura de la foto que se ve y mueve la fila para que quede a la vista
      // (se mueve solo la fila, en horizontal: scrollIntoView movería también la página).
      marcar(i) {
        if (!this.minis || i === this.indice) return;
        this.indice = i;
        var fila = this.minis;
        fila.querySelectorAll('[data-ir]').forEach(function (b) {
          if (+b.dataset.ir === i) {
            b.setAttribute('aria-current', 'true');
            var li = b.parentNode;
            fila.scrollTo({ left: li.offsetLeft - (fila.clientWidth - li.offsetWidth) / 2, behavior: 'smooth' });
          } else {
            b.removeAttribute('aria-current');
          }
        });
      }

      abrir(i) {
        if (!this.lb || typeof this.lb.showModal !== 'function') return;
        // Las imágenes grandes se piden al abrir, no al cargar la ficha.
        this.lb.querySelectorAll('img[data-src]').forEach(function (img) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        });
        this.lb.showModal();
        var p = this.lb.querySelector('[data-lb-pista]');
        p.scrollLeft = p.clientWidth * i;
      }
    }
    customElements.define('cr-galeria', CrGaleria);
  }

  // ---- Reseña compacta que rota (snippets/cr-resena-mini.liquid) -------------
  if (!customElements.get('cr-resena-mini')) {
    class CrResenaMini extends HTMLElement {
      connectedCallback() {
        if (this._listo) return;
        this._listo = true;
        this.diapos = this.querySelectorAll('[data-rm-diapo]');
        this.puntos = this.querySelectorAll('[data-rm-punto]');
        var tarjeta = this.querySelector('[data-rm-tarjeta]');
        if (!tarjeta || this.diapos.length < 2) return;
        this.i = 0;
        this.quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Deslizar con el dedo: más de 30 px en horizontal cambia de reseña (y no cuenta como pulsación)
        var x0 = null, deslizo = false;
        tarjeta.addEventListener('touchstart', function (e) {
          x0 = e.touches[0].clientX;
          deslizo = false;
          this.parar();
        }.bind(this), { passive: true });
        tarjeta.addEventListener('touchend', function (e) {
          var dx = x0 === null ? 0 : e.changedTouches[0].clientX - x0;
          x0 = null;
          if (Math.abs(dx) > 30) {
            deslizo = true;
            this.ir(this.i + (dx < 0 ? 1 : -1));
          }
          // tras tocarla se queda quieta un rato y luego sigue rotando (al deslizar, se reinician los 5 s)
          this.arrancar(Math.abs(dx) > 30 ? 0 : 8000);
        }.bind(this), { passive: true });
        // Arrastrar con el ratón: igual que deslizar con el dedo
        var mx0 = null;
        tarjeta.addEventListener('dragstart', function (e) { e.preventDefault(); });
        tarjeta.addEventListener('mousedown', function (e) {
          if (e.button !== 0) return;
          mx0 = e.clientX;
          deslizo = false;
        });
        window.addEventListener('mouseup', function (e) {
          if (mx0 === null) return;
          var dx = e.clientX - mx0;
          mx0 = null;
          if (Math.abs(dx) > 30) {
            deslizo = true; // el clic que llega después no baja a las reseñas
            this.ir(this.i + (dx < 0 ? 1 : -1));
            this.arrancar();
            setTimeout(function () { deslizo = false; }, 0);
          }
        }.bind(this));
        tarjeta.addEventListener('mouseenter', this.parar.bind(this));
        tarjeta.addEventListener('mouseleave', function () { this.arrancar(); }.bind(this));
        tarjeta.addEventListener('focus', this.parar.bind(this));
        tarjeta.addEventListener('blur', function () { this.arrancar(); }.bind(this));

        // Puntos y flechas de la fila de controles, y flechas del teclado: cambian de reseña y reinician los 5 s
        this.addEventListener('click', function (e) {
          var punto = e.target.closest('[data-rm-punto]');
          var flecha = e.target.closest('[data-rm-mover]');
          if (punto) this.ir(+punto.dataset.rmPunto);
          else if (flecha) this.ir(this.i + +flecha.dataset.rmMover);
          else return;
          this.arrancar();
        }.bind(this));
        tarjeta.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          this.ir(this.i + (e.key === 'ArrowRight' ? 1 : -1));
          this.arrancar();
        }.bind(this));

        // Pulsar: baja a las reseñas de más abajo
        tarjeta.addEventListener('click', function (e) {
          if (deslizo) { deslizo = false; e.preventDefault(); return; }
          var destino = document.querySelector(tarjeta.getAttribute('href'));
          if (!destino) return; // sin destino, el enlace no hace nada raro
          e.preventDefault();
          destino.scrollIntoView({ behavior: this.quieto ? 'auto' : 'smooth', block: 'start' });
        }.bind(this));

        // Solo rota mientras está en pantalla
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) {
            this.visible = es[0].isIntersecting;
            this.visible ? this.arrancar() : this.parar();
          }.bind(this)).observe(this);
        } else {
          this.visible = true;
          this.arrancar();
        }
      }

      ir(n) {
        var total = this.diapos.length;
        this.i = (n + total) % total;
        this.diapos.forEach(function (d, k) {
          var activa = k === this.i;
          d.classList.toggle('is-activa', activa);
          if (activa) d.removeAttribute('aria-hidden');
          else d.setAttribute('aria-hidden', 'true');
        }, this);
        this.puntos.forEach(function (p, k) {
          p.classList.toggle('is-activo', k === this.i);
          if (k === this.i) p.setAttribute('aria-current', 'true');
          else p.removeAttribute('aria-current');
        }, this);
      }

      parar() {
        clearTimeout(this._t);
        clearInterval(this._r);
      }

      // Rotación automática cada 5 s (nunca con movimiento reducido). espera: pausa previa en ms.
      arrancar(espera) {
        this.parar();
        if (this.quieto || !this.visible) return;
        var rotar = function () {
          this._r = setInterval(function () { this.ir(this.i + 1); }.bind(this), 5000);
        }.bind(this);
        if (espera) this._t = setTimeout(rotar, espera);
        else rotar();
      }
    }
    customElements.define('cr-resena-mini', CrResenaMini);
  }

  // ---- Vídeos de clientes (snippets/cr-videos-clientes.liquid) ---------------
  // En silencio. El vídeo no se descarga hasta que se toca o se le pasa el ratón.
  if (!customElements.get('cr-videos-clientes')) {
    class CrVideosClientes extends HTMLElement {
      connectedCallback() {
        if (this._listo) return;
        this._listo = true;
        var tarjetas = Array.prototype.slice.call(this.querySelectorAll('[data-vc]'));
        var conRaton = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

        function parar(t) {
          var v = t.querySelector('video');
          if (v && !v.paused) v.pause();
          t.classList.remove('is-viendo');
        }
        function reproducir(t) {
          tarjetas.forEach(function (o) { if (o !== t) parar(o); });
          var v = t.querySelector('video');
          if (!v) return;
          if (!v.getAttribute('src')) v.src = t.dataset.src; // carga diferida
          v.muted = true;
          v.playsInline = true;
          t.classList.add('is-viendo');
          var p = v.play();
          if (p && p.catch) p.catch(function () { t.classList.remove('is-viendo'); });
        }

        tarjetas.forEach(function (t) {
          if (conRaton) {
            t.addEventListener('mouseenter', function () { reproducir(t); });
            t.addEventListener('mouseleave', function () { parar(t); });
          }
          // Tocar (o Intro con teclado): reproduce o para. Con ratón ya se reproduce al pasar por encima.
          t.addEventListener('click', function (e) {
            if (conRaton && e.detail) return;
            t.classList.contains('is-viendo') ? parar(t) : reproducir(t);
          });
        });

        // Al salir de la pantalla (o del carrusel), se para
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (es) {
            es.forEach(function (e) { if (!e.isIntersecting) parar(e.target); });
          }, { threshold: 0.25 });
          tarjetas.forEach(function (t) { io.observe(t); });
        }
      }
    }
    customElements.define('cr-videos-clientes', CrVideosClientes);
  }

  // ---- Comparador triple (snippets/cr-comparador.liquid) ----------------------
  // Dos tiradores sobre tres fotos superpuestas. Las posiciones (0-100) van en --a y --b.
  if (!customElements.get('cr-comparador')) {
    class CrComparador extends HTMLElement {
      connectedCallback() {
        if (this._listo) return;
        this._listo = true;
        var MIN = 4, MAX = 96, HUECO = 12; // márgenes y separación mínima entre tiradores, en %
        var self = this;
        this.pos = { a: 28, b: 72 };

        function poner(cual, valor) {
          // el izquierdo no pasa al derecho, ni al revés
          if (cual === 'a') valor = Math.max(MIN, Math.min(valor, self.pos.b - HUECO));
          else valor = Math.min(MAX, Math.max(valor, self.pos.a + HUECO));
          self.pos[cual] = valor;
          self.style.setProperty('--' + cual, valor.toFixed(2));
          var t = self.querySelector('[data-tirador="' + cual + '"]');
          if (t) t.setAttribute('aria-valuenow', Math.round(valor));
        }
        this.poner = poner;

        this.querySelectorAll('[data-tirador]').forEach(function (t) {
          var cual = t.dataset.tirador;
          var activo = false;
          t.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            activo = true;
            self.cancelarDemo();
            try { t.setPointerCapture(e.pointerId); } catch (err) {}
            e.preventDefault();
          });
          t.addEventListener('pointermove', function (e) {
            if (!activo) return;
            var r = self.getBoundingClientRect();
            poner(cual, ((e.clientX - r.left) / r.width) * 100);
          });
          function soltar() { activo = false; }
          t.addEventListener('pointerup', soltar);
          t.addEventListener('pointercancel', soltar);
          t.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
            e.preventDefault();
            self.cancelarDemo();
            poner(cual, self.pos[cual] + (e.key === 'ArrowRight' ? 3 : -3));
          });
        });

        // Demostración, una sola vez al entrar en pantalla: el tirador derecho va hasta el 55 % y vuelve,
        // luego el izquierdo hasta el 45 % y vuelve (1,5 s en total). Nunca con movimiento reducido.
        var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!quieto && 'IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (es) {
            if (!es[0].isIntersecting) return;
            io.disconnect();
            self.demo();
          }, { threshold: 0.5 });
          io.observe(this);
        }
      }

      demo() {
        var self = this, inicio = null, MITAD = 750;
        // ida y vuelta suave: 0 → 1 → 0
        function vaiven(p) { return Math.sin(Math.PI * p); }
        function paso(ahora) {
          if (self._sinDemo) return;
          if (inicio === null) inicio = ahora;
          var t = ahora - inicio;
          if (t < MITAD) {
            self.poner('b', 72 - 17 * vaiven(t / MITAD));
          } else if (t < MITAD * 2) {
            self.poner('b', 72);
            self.poner('a', 28 + 17 * vaiven((t - MITAD) / MITAD));
          } else {
            self.poner('a', 28);
            self.poner('b', 72);
            return;
          }
          self._raf = requestAnimationFrame(paso);
        }
        this._raf = requestAnimationFrame(paso);
      }

      // Si el cliente toca un tirador durante la demostración, manda él
      cancelarDemo() {
        this._sinDemo = true;
        if (this._raf) cancelAnimationFrame(this._raf);
      }
    }
    customElements.define('cr-comparador', CrComparador);
  }

  // ---- Fechas de entrega (días laborables) -----------------------------------
  function sumarLaborables(fecha, dias) {
    var d = new Date(fecha);
    while (dias > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) dias--;
    }
    return d;
  }
  function rango(texto) {
    var n = String(texto).match(/\d+/g) || [];
    return n.map(Number);
  }
  var fmt = new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'short' });
  function formatear(d) { return fmt.format(d).replace('.', ''); }

  document.querySelectorAll('[data-cr-entrega]').forEach(function (el) {
    var hoy = new Date();
    var fab = rango(el.dataset.fab);
    var total = rango(el.dataset.total);
    if (!fab.length || !total.length) return;
    var poner = function (clave, a, b) {
      var s = el.querySelector('[data-fecha="' + clave + '"]');
      if (!s) return;
      var da = sumarLaborables(hoy, a);
      var db = sumarLaborables(hoy, b);
      var ini = formatear(da);
      var fin = formatear(db);
      // Mismo mes: "25–28 sept" (cabe en una línea en móvil)
      if (ini === fin) s.textContent = ini;
      else if (da.getMonth() === db.getMonth()) s.textContent = da.getDate() + '–' + fin;
      else s.textContent = ini + ' – ' + fin;
    };
    poner('fab', fab[0], fab[fab.length - 1]);
    poner('total', total[0], total[total.length - 1]);
  });


  // ---- Packs: enlace antiguo a una variante que ya no se ofrece ----------------
  // La variante Maletero no tiene tarjeta. Si la página llega con ella elegida (enlace antiguo con
  // ?variant=), no hay ningún pack marcado: se marca Interior completo y Dawn actualiza precio y URL.
  document.addEventListener('DOMContentLoaded', function () {
    var vs = document.querySelector('.cr-pdp variant-selects');
    if (!vs || vs.querySelector('input[type="radio"]:checked')) return;
    var defecto = vs.querySelector('[data-cr-pack="interior"] input') || vs.querySelector('input[type="radio"]');
    if (!defecto) return;
    defecto.checked = true;
    defecto.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ---- Barra fija en móvil ---------------------------------------------------
  document.querySelectorAll('.cr-pdp').forEach(function (pdp) {
    var barra = pdp.querySelector('[data-barra]');
    var comprar = pdp.querySelector('[data-comprar]');
    var accion = pdp.querySelector('[data-barra-accion]');
    if (!barra || !comprar || !accion) return;

    var tieneModelo = false;
    var aConsultar = false;
    var picker = pdp.querySelector('cr-model-picker');

    function pintarAccion() {
      accion.textContent = !tieneModelo ? 'Elegir mi coche' : aConsultar ? 'Consultar' : 'Añadir al carrito';
    }
    pintarAccion();

    pdp.addEventListener('cr:modelo', function (e) {
      var m = e.detail && e.detail.modelo;
      tieneModelo = !!m;
      aConsultar = !!(m && m.estado);
      pintarAccion();
    });

    // Visible solo cuando el cliente ya ha pasado el botón de compra (queda por encima de la
    // pantalla). Al abrir la página y mientras se configura no sale: el botón aún está por debajo.
    // Tampoco mientras se escribe en el buscador de coche.
    var configurar = pdp.querySelector('#cr-configurar');
    var pasado = false, escribiendo = false;
    function pintarBarra() { barra.hidden = !pasado || escribiendo; }
    // Se mide al hacer scroll (no con IntersectionObserver): con un salto por ancla, de arriba del
    // todo a las reseñas o al revés, el botón no llega a cruzar la pantalla y el observador no avisa.
    var enCola = false;
    function medir() {
      enCola = false;
      pasado = comprar.getBoundingClientRect().bottom < 0;
      pintarBarra();
    }
    function alMover() { if (!enCola) { enCola = true; requestAnimationFrame(medir); } }
    window.addEventListener('scroll', alMover, { passive: true });
    window.addEventListener('resize', alMover);
    medir();
    if (configurar) {
      configurar.addEventListener('focusin', function () { escribiendo = true; pintarBarra(); });
      configurar.addEventListener('focusout', function () { escribiendo = false; pintarBarra(); });
    }

    accion.addEventListener('click', function () {
      var boton = comprar.querySelector('button[type="submit"][name="add"]');
      if (tieneModelo && !aConsultar && boton) {
        // El clic pasa por la misma validación (pregunta, etc.) que el botón normal.
        boton.click();
        return;
      }
      // Sin coche: al buscador. Modelo a consultar: al bloque de WhatsApp (dentro del mismo paso).
      var destino = pdp.querySelector('#cr-configurar');
      if (destino) destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var input = picker && picker.querySelector('[data-input]');
      if (input && !tieneModelo) setTimeout(function () { input.focus({ preventScroll: true }); }, 400);
    });

    // Precio y pack de la barra al cambiar de variante (evento de Dawn).
    // El precio se copia de la tarjeta de pack marcada: mismo formato de moneda que el resto de la tienda.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (!v) return;
        var pack = barra.querySelector('[data-barra-pack]');
        var precio = barra.querySelector('[data-barra-precio]');
        var marcado = pdp.querySelector('variant-selects input[type="radio"]:checked');
        var tarjeta = marcado && marcado.closest('[data-cr-pack]');
        var texto = tarjeta && tarjeta.querySelector('.cr-pk-price');
        if (pack) pack.textContent = v.title;
        if (precio && texto) precio.textContent = texto.textContent.trim();
      });
    }
  });
})();
